import { Button } from "@material-ui/core";
import { invoicePermissionProfile } from "components/Authorize/permissionProfiles/invoicePermissionProfile";
import NotesTooltip from "features/notes/NotesTooltip";
import { NoteEntityTypes } from "features/notes/notesConsts";
import { VehicleLinks } from 'features/vehicles/components/VehicleLinks/VehicleLinks';
import StatusCell from "./components/StatusCell";
import InvoiceErrors from "./components/InvoiceErrors";

export const VendorInvoiceStatus = {
    PENDING: 1,
    APPROVED: 2,
    NEEDS_ATTENTION: 3,
    REJECTED: 4,
    SENT_TO_QB: 5,
    PAYMENT_MADE: 6
};

export const VendorInvoiceStatuses = {
    [VendorInvoiceStatus.PENDING]: {
        id: VendorInvoiceStatus.PENDING,
        name: 'Pending',
        color: '#0e5ab1ff'
    },
    [VendorInvoiceStatus.APPROVED]: {
        id: VendorInvoiceStatus.APPROVED,
        name: 'Approved',
        color: '#4CAF50'
    },
    [VendorInvoiceStatus.NEEDS_ATTENTION]: {
        id: VendorInvoiceStatus.NEEDS_ATTENTION,
        name: 'Needs Attention',
        color: '#FFA726'
    },
    [VendorInvoiceStatus.REJECTED]: {
        id: VendorInvoiceStatus.REJECTED,
        name: 'Rejected',
        color: '#EF5350'
    },
    [VendorInvoiceStatus.SENT_TO_QB]: {
        id: VendorInvoiceStatus.SENT_TO_QB,
        name: 'Sent To QB',
        color: '#26C6DA'
    },
    [VendorInvoiceStatus.PAYMENT_MADE]: {
        id: VendorInvoiceStatus.PAYMENT_MADE,
        name: 'Payment Made',
        color: '#66BB6A'
    }
}

export const VendorInvoiceStatusesList = Object.values(VendorInvoiceStatuses)

export const getVendorInvoiceColumns = ({ setInvoiceToPreview, setInvoiceToEdit, mappedInvoices, canEdit }) => [
    {
        name: 'Invoice Number',
        key: 'invoiceNumber',
        editable: false,
        component: (row) =>
            canEdit ? (<Button
                color="primary"
                onClick={() => setInvoiceToEdit(mappedInvoices?.find(inv => inv.id === row.id))}
            >
                {row?.invoiceNumber}
            </Button>
            ) :
                <div>{row?.invoiceNumber}</div>

    },
    {
        name: 'Vendor Name',
        key: 'vendorName',
        editable: false,
    },
    {
        name: 'Parq Vendor',
        key: 'parqVendorName',
        editable: false,
    },
    {
        name: 'QB Vendor',
        key: 'qbVendorName',
        editable: false,
    },
    {
        name: 'Invoice Date',
        key: 'formattedDate',
        editable: false,
    },
    {
        name: "Assets",
        width: 220,
        key: 'vehicles',
        component: (row) => <VehicleLinks vehicles={row?.vehiclesWithParqId} />
    },

    {
        name: 'Subtotal',
        key: 'subTotal',
        editable: false,
        component: (row) => <div>${row?.subTotal}</div>
    },
    {
        name: 'Tax',
        key: 'tax',
        editable: false,
        component: (row) => <div>${row?.tax}</div>
    },
    {
        name: 'Total Amount',
        key: 'total',
        editable: false,
        component: (row) => <div>${row?.total}</div>
    },

    {
        name: 'Invoice File',
        key: 'fileUrl',
        editable: false,
        component: (row) => row?.fileUrl ? (
            <Button
                color='primary'
                onClick={() => {
                    setInvoiceToPreview(row);
                }}
            >
                View File
            </Button>
        ) : <div>No File</div>
    },
    {
        name: "Notes",
        editable: false,
        width: 70,
        key: "id",
        component: (row) => <NotesTooltip
            editPermissionProfile={invoicePermissionProfile.EDIT_VENDOR_INVOICE}
            hideViewByClient={true}
            entityId={row?.id}
            entityType={NoteEntityTypes.VENDORINVOICES}
        />
    },
    {
        name: 'Status',
        key: 'statusId',
        editable: false,
        component: (row) => <StatusCell row={row} />
    },
    {
        name: "Errors",
        editable: false,
        key: "errors",
        component: (row) => <InvoiceErrors invoice={row} />
    },
];